export default __webpack_public_path__ + "static/media/Flaticon.23693237.eot";